import { PillsInput } from '@mantine/core';

const PillsInputDefaults = PillsInput.extend({
  defaultProps: {
    radius: 'sm',
  },
});

export { PillsInput, PillsInputDefaults };
